import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { pdfFiles, PDFdownloadButton } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const HouseholdRules = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        pdfFile={pdfFiles.strategiesPart2[0]}
        vidSrc={1194418578}
      />
    </div>
  );
};

export default HouseholdRules;
